import React, { useState, useContext, useRef } from "react";
import { AuthContext } from '../../contexts/auth';
import { FiUpload, FiX } from 'react-icons/fi';

import { uploadArquivo, verificaProcessamento } from '../../services/apigateway';
import { toast } from 'react-toastify';
import Globais from '../../components/Globais/Globais';
import { useUploadProgress } from '../../contexts/UploadProgressProvider.js';

import Cabecalho from '../../components/Cabecalho/cabecalho';
import Titulo from '../../components/Titulo/titulo';
import Rodape from '../../components/Rodape/rodape';
import Menu from '../../components/Menu/menu';
//import Footer from '../../components/Footer/footer';

import ProcessandoModal from "../../components/Processamento/processamento";
import { GiConsoleController } from "react-icons/gi";

export default function UploadZip () {
  const { clientes, clientSelected, ligaMenu, usuario } = useContext(AuthContext);
  const { startTracking } = useUploadProgress();
  const [file, setFile] = useState(null);
  const [mensagem, setMensagem] = useState("");
  const [loading, setLoading] = useState(false);

  const fileInputRef = useRef(null);

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleSelecionar = (e) => {
    setFile(e.target.files[0]);
    setMensagem("");
  };

  const handleUploadZip = async () => {
    if (!file) {
      setMensagem("Selecione um arquivo.");
      toast.error('Selecione um arquivo para importação!');
      return;
    }

    if (file.name.substring(0, 8) != clientes[clientSelected].idt_cliente) {
      toast.error("Arquivo não pertence ao cliente atual");
      return;
    }

    // Verificar se já existe um jobId em Tab_ConWebSoket - Apenas um processamento por vez...
    const result = await verificaProcessamento();

    if (result[0].qtd !== 0) {
      toast.error("Já existe um Arquivo em processamento. Tente mais tarde.");
      return;
    }
  
    try {
      setLoading(true);

      // Marca início
      const inicio = new Date();
      console.log("Início do upload:", inicio.toISOString());

      const jobId = crypto.randomUUID();
      startTracking(jobId);

      const response = await uploadArquivo(file, usuario.codigo, jobId);
  
      if (response.data.statusCode === 200) {
        // Marca fim
        const fim = new Date();
        console.log("Fim do upload:", fim.toISOString());

        console.log("Upload efetuado com sucesso");
        toast.success("Upload concluído com sucesso! Processamento será inciado automaticamente");

      } else {
        console.log(JSON.parse(response.data.body).error);
        toast.error(JSON.parse(response.data.body).error);
      }

    } catch (error) {
      console.error("Erro ao enviar o arquivo:", error);
      toast.error("Erro ao enviar o arquivo zip.");
      
    } finally {
      setLoading(false);
    }
  };

  if (loading){
    return(
      <div className='container md:w-11/12 w-full mx-auto md:mt-4 bg-white'>
        <Cabecalho />
      
      <main>
        <Titulo tela={'Importação de Arquivos'} />

        <section
          className="md:grid grid-cols-1"
          style={{
            gridTemplateColumns: ligaMenu
              ? 'minmax(175px, 20%) minmax(60%, 80%)'
              : 'minmax(48px, 5%) minmax(70%, 95%)',
          }}
        >
          <Menu />
          <ProcessandoModal open={loading} message="Aguarde, processando arquivo de importação..." />
        </section>
      </main>
    </div>
    )
  }
 
  return (
    <div className='container md:w-11/12 w-full mx-auto md:mt-4 bg-white'>
      <Cabecalho />
      
      <main>
        <Titulo tela={'Importação de Arquivos'} /> 

        <section
          className="md:grid grid-cols-1"
          style={{
            gridTemplateColumns: ligaMenu
              ? 'minmax(175px, 20%) minmax(60%, 80%)'
              : 'minmax(48px, 5%) minmax(70%, 95%)',
          }}
        >
          <Menu />
        <div>
        <h3 className="text-xl font-semibold text-gray-800 text-center">Importação de Arquivos</h3>

        <div className="relative flex items-center">
          {/* Botão customizado */}
          <button
            type="button"
            onClick={handleClick}
            className="flex items-center gap-4"
          >
            <label className="text-xl font-semibold text-gray-800 text-center">Selecionar</label>
            <FiUpload color='green' />

            {file && (
              <div>
                {file.name}
              </div>
            )}
          </button>
          {/* Input escondido */}
          <input
            type="file"
            accept=".zip"
            ref={fileInputRef}
            onChange={handleSelecionar}
            className="hidden"
          />
        </div>

        <div className="flex gap-4 pt-6 mt-6 mb-6 border-t border-secondary justify-center">
          <button  
            className='border border-secondary text-secondary hover:bg-secondary hover:text-white px-10 py-2 rounded-md'
            onClick={handleUploadZip}>
              Processar
          </button>
        </div>
      </div>

        </section>
      </main>

      <Rodape versao={Globais.versao}/>
    </div>

  );
};

